<template>
    <section class="w-full pt-8 px-4">
      <div :class="darkMode ? 'bg-darkmode-hard' : 'bg-white'" class="hero-bar transition-colors duration-1000 text-center md:text-left">
        <slot />
      </div>
        <!-- <level> -->
            <!-- <h2 class="text-3xl font-semibold leading-tight"> -->
                <!-- <slot /> -->
            <!-- </h2> -->
        <!-- </level> -->
    </section>
</template>

<script>
    import { mdiThemeLightDark } from '@mdi/js'
    import { useStore } from 'vuex'
    import { computed } from 'vue'
    // import Level from '@/components/Level'

    export default {
        name: 'HeroBar',
        components: {
            // Level
        },
        setup () {
            const store = useStore()
            const darkMode = computed(() => store.state.darkMode)

            const darkModeToggle = () => {
                store.dispatch('darkMode')
            }

            return {
                darkMode,
                darkModeToggle,
                mdiThemeLightDark
            }
        }
    }
</script>
